import React from 'react';
import { FaUpload, FaCheckCircle } from 'react-icons/fa';
import { MAX_FILE_SIZE_MB } from './Constants';

function UploadBox({ proof, proofError, hasError, fileInputRef, onFileChange, onBoxClick }) {
  return (
    <>
      <div
        className={`upload-box ${proof ? 'upload-success' : ''} ${hasError ? 'input-error' : ''}`}
        role="button"
        tabIndex={0}
        aria-label="Upload proof of payment"
        onClick={onBoxClick}
        onKeyDown={(e) => e.key === 'Enter' && onBoxClick()}
      >
        {proof ? (
          <>
            <FaCheckCircle className="upload-check" />
            <p>{proof.name}</p>
          </>
        ) : (
          <>
            <FaUpload />
            <p>Upload proof of payment *</p>
            <small style={{ opacity: 0.5, fontSize: '0.78rem', marginTop: '0.3rem' }}>
              JPG, PNG, WEBP or PDF — max {MAX_FILE_SIZE_MB}MB
            </small>
          </>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*,application/pdf"
          hidden
          onChange={onFileChange}
        />
      </div>
      {proofError && (
        <p
          className="field-error-msg"
          style={{ marginTop: '-1rem', marginBottom: '1rem' }}
          aria-live="polite"
        >
          ⚠️ {proofError}
        </p>
      )}
    </>
  );
}

export default UploadBox;